import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPngToBmpConfig } from '@/data/landingConfig/landingPngToBmpConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PngToBmp } from './schemaObject';

interface Props {}
const PngToBmpConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PngToBmp} />
			<LandingTemplate
				data={landingPngToBmpConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default PngToBmpConverter;
